import React from 'react';
// Libs
import events from '../../lib/events.js';

// Page object
class printable extends React.Component {
  state = {
    display: null,
    loaded: false,
  };

  componentDidMount() {
    // Subscribe to events
    this._eventPrint = events.subscribe('print', this.doPrint);
    this._eventAfterPrint = events.subscribe('afterPrint', this.afterPrint);
  }

  componentWillUnmount() {
    this._eventPrint.remove();
    this._eventAfterPrint.remove();
  }

  componentDidUpdate() {
    if (this.state.display) {
      setTimeout(() => window.print(), 100);
    }
  }

  _eventPrint = null;
  _eventAfterPrint = null;

  doPrint = (data) => {
    this.setState({display: data});
  };

  afterPrint = () => {
    this.setState({display: null});
  }

  printOnLoad = () => {
    this.state.loaded = true;
  }

  render() {
    return (
      <div className='visible-print-block' onLoad={this.printOnLoad}> 
        {this.state.display}
      </div>
    );
  }
}

export default printable;
